import React from 'react';
import { connect } from 'react-redux';
import { changeEditOrder, changeItemEditOrder, checkedAllItemsEditOrder, changeInforEditOrder } from './../../../../../actions/editOrder';
import ItemsComponent from './../../../components/items';
import RowItem from './RowItem';
import './styles.css';
import { iconEmpty } from './../../../../../services/helper'

class Items extends ItemsComponent {
    renderRow = () => {
        let items = [...this.props.itemOrder]
        if (!items.length) {
            return (
                <tr>
                    <td colSpan={11}>{iconEmpty()}</td>
                </tr>
            )
        }
        let skusExists = [];
        return items.map((value, key) => {
            if (value.sku && skusExists.indexOf(value.sku) > -1) {
                value.classes.sku = 'error'
            } else {
                skusExists.push(value.sku)
            }
            return <RowItem
                itemData={value}
                key={key}
                no={key + 1}
                validateEmpty={this.props.validateEmpty}
                pageType={this.props.pageType}
                maxSizeSku={this.props.maxSizeSku}
                prohibitedItems={this.props.prohibitedItems}
            />
        })
    }

    componentDidMount() {
        this.props.onChangeItem([])
    }
}

const mapStateToProps = state => {
    return {
        itemOrder: state.editOrder.items,
        order: state.editOrder,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onChangeItem: payload => {
            dispatch(changeItemEditOrder(payload))
        },
        checkedAllItems: payload => {
            dispatch(checkedAllItemsEditOrder(payload))
        },
        onChange: payload => {
            dispatch(changeEditOrder(payload))
        },
        onChangeInformation: payload => {
            dispatch(changeInforEditOrder(payload))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Items)



// WEBPACK FOOTER //
// ./src/containers/orders/edit/components/items/index.js